// extracted by css-extract-rspack-plugin
export default {"Box":"repo-list-module__Box__LS7hxSU","Text":"repo-list-module__Text__ziXeXOP"};